export const EXEM_ONE_DOCS_LINK = '/exemone-docs/docs/메뉴얼/';
